import { getEstimate, getEstimates, getGraphCategories, getOrderDetails, getOrderList, getOrderListCount,getOrderDocuments } from "../api";

export const getOrdersReq = async (body = {}) => {
    const response = await getOrderList(body);
    return response.payload.data;
};

export const getOrdersListCountReq = async (body = {}) => {
    const response = await getOrderListCount(body);
    return response.payload.data;
};


export const getOrderDetailsReq = async(body={})=>{
    const response =await getOrderDetails(body);
    return response.payload;
}
export const getOrderDocumentSReq = async (orderId, documentId) => {
    const response=await getOrderDocuments(orderId, documentId);
    return response
};

export const getEstimatesReq = async(body={})=>{
    const response =await getEstimates(body);
    return response.payload;
}

export const getEstimateReq = async(body={}, id)=>{
    const response =await getEstimate(body, id);
    return response.payload;
}
export const getGraphCategoriesReq = async(body={}, id)=>{
    const response =await getGraphCategories(body, id);
    return response.payload;
}